import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState } from 'react';
import Select from 'react-select';
import { API_URL } from '..';

const InvoiceAddLayer = () => {
    const [currentUser, setCurrentUser] = useState({})
    const [invoiceData, setInvoiceData] = useState({
        invoiceNumber: "3492",
        issuedDate: "25/08/2020",
        dueDate: "29/08/2020",
        customerName: "Customer Name",
        customerAddress: "Type Address Here...",
        customerPhone: "Customer Phone...",
    });

    const [message, setMessage]= useState({
        status:false,
        reason:'',
        desc:''
    })
    const [showDiscount, setShowDiscount] = useState(false); // Tracks the currently editing field
    const [showTax, setShowTax] = useState(false); // Tracks the currently editing field
    const [editingField, setEditingField] = useState(null); // Tracks the currently editing field
    const [invoiceItems, setInvoiceItems] = useState([]);
    const [discount, setDiscount] = useState(0); // Discount in percentage

    const [newItem, setNewItem] = useState({
        itemName: null,
        qty: '',
        unitPrice: '',
    });
   const getCurrentUser = () =>{
    const user = JSON.parse(localStorage.getItem('user'));
    setCurrentUser(user)
   }
   React.useEffect(()=>{
    getCurrentUser();
    fetchStock()
   },[1])
    const handleInputChange = (field, value) => {
       
        setNewItem({ ...newItem, [field]: value });
    };

    const addItem = () => {
        if (
            newItem.itemName &&
            newItem.qty  &&
            newItem.unitPrice
        ) {
            setInvoiceItems([
                ...invoiceItems,
                {
                    ...newItem,
                    id: invoiceItems.length + 1,
                    price: (newItem.qty * newItem.unitPrice).toFixed(2),
                },
            ]);
            setNewItem({ itemName: null, qty: '',  unitPrice: '' });
        }
    };

    const removeItem = (id) => {
        setInvoiceItems(invoiceItems.filter((item) => item.id !== id));
    };
    const [stockList, setStockList] = useState([])
    const fetchStock =  async()=>{
        const user = JSON.parse(localStorage.getItem('user'));
        if(!user){
          window.location.href='/sign-in'
        }else{
          let headersList = {
            "Accept": "*/*",
            "Content-Type": "application/json"
           }
          let response = await fetch( API_URL+`/api/invoice/stock/fetch`, { 
            method: "GET",
            headers: headersList
          });
          const data = await response.json();
          console.log(data)
          const formatted = data.stock.map((e)=>({label:e.title, value : e.id})) 
          setStockList(formatted)
        } 
    }
    const onChangeStock =  async(value)=>{
        console.log(value)
        const user = JSON.parse(localStorage.getItem('user'));
        if(!user){
          window.location.href='/sign-in'
        }else{
          let headersList = {
            "Accept": "*/*",
            "Content-Type": "application/json"
           }
          let response = await fetch( API_URL+`/api/invoice/stock/fetch-single/${value.value}`, { 
            method: "GET",
            headers: headersList
          });
          const data = await response.json();
          console.log(data)
          setNewItem({
            ...newItem,
            itemName: value,
            unitPrice: data.stock.sellPrice,
          })
          
        } 
    }
    

    // Handle edit start
    const startEditing = (field) => {
        setEditingField(field);
    };

    // Handle input change
    const handleChange = (field, value) => {
        setInvoiceData({ ...invoiceData, [field]: value });
    };

    // Handle edit completion
    const stopEditing = () => {
        setEditingField(null);
    };
    const handleDiscountChange = (value) => {
        setDiscount(value);
    };
    const handleTaxChange = (value) => {
        setTaxAmount(value);
    };

    const calculateSubtotal = () =>
        invoiceItems.reduce((acc, item) => acc + parseFloat(item.price), 0);

    const calculateDiscountedTotal = () => {
        const subtotal = calculateSubtotal();
        const discountAmount = (subtotal * discount) / 100;
        return subtotal - discountAmount;
    };
    const [taxAmount,setTaxAmount] = useState(0)
    const calculateTax = (total) => total * taxAmount / 100; // 10% tax

    const calculateTotal = () => {
        const discountedTotal = calculateDiscountedTotal();
        return discountedTotal + calculateTax(discountedTotal);
    };
    const handleInvoiceSubmit  = async ()=>{
        const user = JSON.parse(localStorage.getItem('user'));
         let headersList = {
            "Accept": "*/*",
            "Content-Type": "application/json"
           }
         const bodyContent =  JSON.stringify({
                "invoice_number":invoiceData.invoiceNumber,
                "customer_name": invoiceData.customerName,
                "phone": invoiceData.customerPhone,
                "address": invoiceData.customerAddress,
                "issue_date":invoiceData.issuedDate,
                "due_date":invoiceData.dueDate,
                "amount":calculateTotal(),
                "discount": discount,
                "tax": taxAmount,
                "job_id": null,
                "items": invoiceItems
            })
            const response = await fetch(API_URL+'/api/invoice/create',{
                method:'POST',
                headers:headersList,
                body:bodyContent
            })
            const data = await response.json();
            if(response.status === 201){
                setMessage({
                    status:true,
                    reason:'success',
                    desc:'Invoice is added successfully'
                })
                setNewItem({
                    itemName:'',
                    qty:'',
                    unitPrice:''
                })
            }else{
                setMessage({
                    status:true,
                    reason:'error',
                    desc:'Invoice is not added'
                })
            }



    }
    return (
        <div className="card">
            <div className="card-header">
                <div className="d-flex flex-wrap align-items-center justify-content-end gap-2">
                    <button
                      onClick={()=>handleInvoiceSubmit()}
    
                        className="btn btn-sm btn-primary-600 radius-8 d-inline-flex align-items-center gap-1"
                    >
                        <Icon icon="simple-line-icons:check" className="text-xl" />
                        Save
                    </button>
                </div>
            </div>
            
            <div className="card-body py-40">
                <div className="row justify-content-center" id="invoice">
                {
                      message.status === true ?
                    <div
                        className={
                          message.reason == 'error' ?
                          "alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10":
                          "alert alert-success bg-success-50 text-success-600 border-success-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                        }
                        role="alert"
                    >
                        {message.desc}
                        <button type="button" onClick={()=>setMessage({
                            ...message,
                            status:false
                        })} className="remove-button text-secondary-600 text-xxl line-height-1">
                            {" "}
                            <Icon icon="iconamoon:sign-times-light" className="icon" />
                        </button>
                    </div>:null
                    }
                    <div className="col-lg-8">
                        <div className="shadow-4 border radius-8">
                            <div className="p-20 border-bottom">
                                <div className="row justify-content-between g-3">
                                <div className="col-sm-4">
                                        <h3 className="text-xl">
                                            Invoice #{" "}
                                            {editingField === "invoiceNumber" ? (
                                                <input
                                                    type="text"
                                                    value={invoiceData.invoiceNumber}
                                                    onChange={(e) =>
                                                        handleChange("invoiceNumber", e.target.value)
                                                    }
                                                    onBlur={stopEditing}
                                                    className="editable-input"
                                                />
                                            ) : (
                                                <span
                                                    onClick={() => startEditing("invoiceNumber")}
                                                    className="editable text-decoration-underline"
                                                >
                                                    {invoiceData.invoiceNumber}
                                                </span>
                                            )}
                                        </h3>
                                        <p className="mb-1 text-sm">
                                            Date Issued:{" "}
                                            {editingField === "issuedDate" ? (
                                                <input
                                                    type="text"
                                                    value={invoiceData.issuedDate}
                                                    onChange={(e) =>
                                                        handleChange("issuedDate", e.target.value)
                                                    }
                                                    onBlur={stopEditing}
                                                    className="editable-input"
                                                />
                                            ) : (
                                                <span
                                                    onClick={() => startEditing("issuedDate")}
                                                    className="editable text-decoration-underline"
                                                >
                                                    {invoiceData.issuedDate}
                                                </span>
                                            )}
                                            <span className="text-success-main">
                                                <Icon
                                                    icon="mage:edit"
                                                    onClick={() => startEditing("issuedDate")}
                                                />
                                            </span>
                                        </p>
                                        <p className="mb-0 text-sm">
                                            Date Due:{" "}
                                            {editingField === "dueDate" ? (
                                                <input
                                                    type="text"
                                                    value={invoiceData.dueDate}
                                                    onChange={(e) =>
                                                        handleChange("dueDate", e.target.value)
                                                    }
                                                    onBlur={stopEditing}
                                                    className="editable-input"
                                                />
                                            ) : (
                                                <span
                                                    onClick={() => startEditing("dueDate")}
                                                    className="editable text-decoration-underline"
                                                >
                                                    {invoiceData.dueDate}
                                                </span>
                                            )}
                                            <span className="text-success-main">
                                                <Icon
                                                    icon="mage:edit"
                                                    onClick={() => startEditing("dueDate")}
                                                />
                                            </span>
                                        </p>
                                    </div>
                                    <div className="col-sm-4">
                                        <img src='./assets/images/logo.png' style={{width: 200}}/>
                                        <p className="mb-1 text-sm">
                                            {currentUser.address}
                                        </p>
                                        <p className="mb-0 text-sm">{currentUser.email}</p>
                                        <p className="mb-0 text-sm">{currentUser.phone}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="py-28 px-20">
                                <div className="d-flex flex-wrap justify-content-between align-items-end gap-3">
                                    <div>
                                        <h6 className="text-md">Issus For:</h6>
                                        <table className="text-sm text-secondary-light">
                                    <tbody>
                                        <tr>
                                            <td>Name</td>
                                            <td className="ps-8">
                                                :{" "}
                                                {editingField === "customerName" ? (
                                                    <input
                                                        type="text"
                                                        value={invoiceData.customerName}
                                                        onChange={(e) =>
                                                            handleChange("customerName", e.target.value)
                                                        }
                                                        onBlur={stopEditing}
                                                        className="editable-input"
                                                    />
                                                ) : (
                                                    <span
                                                        onClick={() => startEditing("customerName")}
                                                        className="editable text-decoration-underline"
                                                    >
                                                        {invoiceData.customerName}
                                                    </span>
                                                )}
                                                <span className="text-success-main">
                                                    <Icon
                                                        icon="mage:edit"
                                                        onClick={() => startEditing("customerName")}
                                                    />
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Address</td>
                                            <td className="ps-8">
                                                :{" "}
                                                {editingField === "customerAddress" ? (
                                                    <input
                                                        type="text"
                                                        value={invoiceData.customerAddress}
                                                        onChange={(e) =>
                                                            handleChange("customerAddress", e.target.value)
                                                        }
                                                        onBlur={stopEditing}
                                                        className="editable-input"
                                                    />
                                                ) : (
                                                    <span
                                                        onClick={() => startEditing("customerAddress")}
                                                        className="editable text-decoration-underline"
                                                    >
                                                        {invoiceData.customerAddress}
                                                    </span>
                                                )}
                                                <span className="text-success-main">
                                                    <Icon
                                                        icon="mage:edit"
                                                        onClick={() => startEditing("customerAddress")}
                                                    />
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Phone number</td>
                                            <td className="ps-8">
                                                :{" "}
                                                {editingField === "customerPhone" ? (
                                                    <input
                                                        type="text"
                                                        value={invoiceData.customerPhone}
                                                        onChange={(e) =>
                                                            handleChange("customerPhone", e.target.value)
                                                        }
                                                        onBlur={stopEditing}
                                                        className="editable-input"
                                                    />
                                                ) : (
                                                    <span
                                                        onClick={() => startEditing("customerPhone")}
                                                        className="editable text-decoration-underline"
                                                    >
                                                        {invoiceData.customerPhone}
                                                    </span>
                                                )}
                                                <span className="text-success-main">
                                                    <Icon
                                                        icon="mage:edit"
                                                        onClick={() => startEditing("customerPhone")}
                                                    />
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                    </div>
                                   
                                </div>
                                <div className="mt-24">
                                    <div className="table-responsive scroll-sm">
                                        <table
                                            className="table bordered-table text-sm"
                                            id="invoice-table"
                                        >
                                            <thead>
                                                <tr>
                                                    <th scope="col" className="text-sm">
                                                        SL.
                                                    </th>
                                                    <th scope="col" className="text-sm">
                                                        Items
                                                    </th>
                                                    <th scope="col" className="text-sm">
                                                        Qty
                                                    </th>
                                                    <th scope="col" className="text-sm">
                                                        Unit Price
                                                    </th>
                                                    <th scope="col" className="text-sm">
                                                        Price
                                                    </th>
                                                    <th scope="col" className="text-center text-sm">
                                                        Action
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {invoiceItems.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{item?.itemName?.label}</td>
                                                    <td>{item.qty}</td>
                                                    <td>£{item.unitPrice}</td>
                                                    <td>£{item.price}</td>
                                                    <td className="text-center">
                                                        <button
                                                            type="button"
                                                            className="remove-row btn btn-sm btn-danger"
                                                            onClick={() => removeItem(item.id)}
                                                        >
                                                            <Icon
                                                                icon="ic:twotone-close"
                                                                className="text-xl"
                                                            />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        </table>
                                    </div>
                                    <div>
                                    <div className="d-flex flex-wrap align-items-center gap-2 mt-4">
                                    <tr>
                                    <td> 
                                        <Select name='itemName' value={newItem.itemName} onChange={(e)=> onChangeStock(e)} options={stockList}/> 
                                      </td>
                                                    <td> <input
                                        type="number"
                                        className="form-control text-sm"
                                        placeholder="Quantity"
                                        value={newItem.qty}
                                        onChange={(e) => handleInputChange('qty', e.target.value)}
                                    /></td>
                                                
                                                    <td>   <input
                                        type="number"
                                        className="form-control text-sm"
                                        placeholder="Unit Price"
                                        value={newItem.unitPrice}
                                        onChange={(e) => handleInputChange('unitPrice', e.target.value)}
                                    /></td>
                                                   
                                                    <td className="text-center">
                                                        <button
                                                            type="button"
                                                            className="remove-row btn btn-sm btn-success"
                                                            onClick={addItem}
                                                        >
                                                             <Icon
                                                            icon="simple-line-icons:plus"
                                                            className="text-xl"
                                                        />
                                                        </button>
                                                    </td>
                                                </tr>
                                    
                                  
                                   
                                   
                                 
                                  
                                </div>
                                      
                                    </div>
                                    <div className="d-flex flex-wrap justify-content-between gap-3 mt-24">
                                        <div>
                                           
                                            {/* <p className="text-sm mb-0">Thanks for your business</p> */}
                                        </div>
                                        <div>
                                            <table className="text-sm">
                                                <tbody>
                                                    <tr>
                                                        <td className="pe-64">Subtotal:</td>
                                                        <td className="pe-16">
                                                            <span className="text-primary-light fw-semibold">
                                                            £{calculateSubtotal().toFixed(2)}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        
                                                        <td className="pe-64">Discount in %: <Icon onClick={()=>setShowDiscount(!showDiscount)} icon='mage:edit'/></td>
                                                      {
                                                        showDiscount === true ? 
                                                      <td>
                                                     
                                                      <input
                                                            type="number"
                                                            className="form-control text-sm"
                                                            value={discount}
                                                            onChange={(e) =>
                                                                handleDiscountChange(Number(e.target.value))
                                                            }
                                                            placeholder="Enter discount"
                                                        />
                                                        
                                                      
                                                      </td>:

                                                        <td className="pe-16">
                                                            <span className="text-primary-light fw-semibold">
                                                            £{(
                                                        (calculateSubtotal() * discount) /
                                                        100
                                                    ).toFixed(2)}
                                                            </span>
                                                        </td>
                                                      }
                                                    </tr>
                                                    <tr>
                                                        <td className="pe-64 border-bottom pb-4">Tax: <Icon onClick={()=>setShowTax(!showTax)} icon='mage:edit'/></td>

                                                        {
                                                        showTax === true ? 
                                                      <td>
                                                     
                                                      <input
                                                            type="number"
                                                            className="form-control text-sm"
                                                            value={taxAmount}
                                                            onChange={(e) =>
                                                                handleTaxChange(Number(e.target.value))
                                                            }
                                                            placeholder="Enter discount"
                                                        />
                                                        
                                                      
                                                      </td>:

                                                                <td className="pe-16 border-bottom pb-4">


                                                                <span className="text-primary-light fw-semibold">
                                                                £{calculateTax(calculateDiscountedTotal()).toFixed(
                                                                2
                                                                )}
                                                                </span>
                                                                </td>
                                                      }
                                                        
                                                    </tr>
                                                    <tr>
                                                        <td className="pe-64 pt-4">
                                                            <span className="text-primary-light fw-semibold">
                                                                Total:
                                                            </span>
                                                        </td>
                                                        <td className="pe-16 pt-4">
                                                            <span className="text-primary-light fw-semibold">
                                                            £{calculateTotal().toFixed(2)}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-64">
                                    <p className="text-center text-secondary-light text-sm fw-semibold">
                                        Thank you for your purchase!
                                    </p>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default InvoiceAddLayer;